import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-nw-number-number',
  imports: [],
  templateUrl: './nw-number-number.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './nw-number-number.component.scss',
})
export class NwNumberNumberComponent {
  @Output() public numberEntered = new EventEmitter<string>();

  public onNumberChanged(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value) {
      const number = (+inputElement.value).toString().padStart(3, '0');
      this.numberEntered.emit('NW' + number);
    }
  }
}
